// test884
(884 && 0);
